import React from 'react';
import Input from './Input';

const RangeInput = ({ from, to, ...props }) => (
  <Input value={`${from}${to}`} {...props} />
);

const NumberInput = ({ ...props }) => <Input {...props} onlyNumbers />;

export { RangeInput, NumberInput };

export default Input;
